import { customAlphabet } from "nanoid";

const alphabet = "123456789ABCDEFGHIJKLMNPQRSTUVWXYZ";
const genCode = customAlphabet(alphabet, 8);

export default genCode;
